<app-header></app-header>
<br />
<div class="mobile-author-actions"></div>

<div class="container">
  <div class="container-fluid">
    <div class="social-dash-wrap">
      <div class="row">
        <div class="card">
          <div class="card-body">
            <div class="info-section">
              <h3>Your Rights Under Privacy Laws</h3>
              <p>
                In today’s digital world, your personal data is constantly being
                collected, shared, and sold — often without your clear consent.
                But you have rights. Powerful privacy laws now exist to give you
                more control over your information.
              </p>
              <p>Here’s what you need to know.</p>
            </div>
            <div class="info-section">
              <h5>🧾 1. You Have the Right to Know</h5>
              <p>
                Under laws like the
                <b>California Consumer Privacy Act (CCPA)</b> and
                <b>General Data Protection Regulation (GDPR)</b>, you can ask
                companies:
              </p>
              <ul>
                <li>What personal information they collect about you</li>
                <li>Why they collect it</li>
                <li>Who they share or sell it to</li>
              </ul>
              <p>
                This means you no longer have to wonder what’s happening behind
                the scenes — you can ask for transparency.
              </p>
            </div>
            <div class="info-section">
              <h5>🗑️ 2. You Have the Right to Be Forgotten</h5>
              <p>
                One of the most powerful rights:
                <b
                  >You can request companies to delete your personal
                  information</b
                >. This is known as the “right to erasure” or “right to be
                forgotten.”
              </p>
              <p>
                Once a valid request is made, companies are legally obligated to
                remove your data — and in many cases, inform their partners to
                do the same.
              </p>
            </div>
            <div class="info-section">
              <h5>🛑 3. You Can Say “No” to Data Sales</h5>
              <p>
                In some regions (especially California), you have the right to
                <b>opt out of the sale or sharing of your data</b>. That means
                you can tell data brokers and marketing companies to stop
                profiting off your personal information.
              </p>
              <p>
                By exercising this right, you reduce your digital footprint and
                exposure to unwanted ads, scams, and data misuse.
              </p>
            </div>
            <div class="info-section">
              <h5>🔐 4. You Have the Right to Data Security</h5>
              <p>
                Companies must take
                <b>reasonable steps to protect your data</b>. If they’re
                careless and your data gets breached, you may have the right to
                take legal action — especially if it leads to identity theft or
                harm.
              </p>
            </div>
            <div class="info-section">
              <h5>
                ✍️ 5. You Have the Right to Act Through an Authorized Agent
              </h5>
              <p>
                Don’t want to deal with dozens of companies yourself? Laws like
                the CCPA allow you to
                <b
                  >authorize a trusted agent (like us!) to act on your behalf</b
                >
                — submit removal requests, disputes, and opt-outs in your name.
              </p>
            </div>
            <div class="info-section">
              <h5>🌍 Do These Rights Apply to You?</h5>
              <p>Yes — if you live in:</p>
              <ul>
                <li>
                  The <b>United States</b> (especially California, Virginia,
                  Colorado, and more)
                </li>
                <li>The <b>European Union</b> or <b>UK</b></li>
                <li><b>Canada</b> under certain provincial laws</li>
                <li>
                  Other countries with privacy protections (like Brazil,
                  Australia, and South Korea)
                </li>
              </ul>
              <p>
                Even if your region has weaker laws, many data brokers comply
                voluntarily to avoid risk.
              </p>
            </div>
            <div class="info-section">
              <h5>✅ We’re Here to Help</h5>
              <p>Our job is to make these rights <b>easy to use</b>. We:</p>
              <ul>
                <li>Submit deletion requests to data brokers on your behalf</li>
                <li>Track their responses</li>
                <li>Recheck regularly to keep your information clean</li>
              </ul>
              <p>
                Your privacy is not a luxury — it’s your <b>legal right</b>. And
                we’re here to enforce it for you.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
